import { getApiUrl } from '../config'

export const INTERCOM_USER_JWT_KEY = `${getApiUrl()}:intercom-user-jwt`

export const getIntercomUserJwt = () => {
  return localStorage.getItem(INTERCOM_USER_JWT_KEY)
}

export const setIntercomUserJwt = (jwt: string) => {
  localStorage.setItem(INTERCOM_USER_JWT_KEY, jwt)
}

export const unsetIntercomUserJwt = () => {
  localStorage.removeItem(INTERCOM_USER_JWT_KEY)
}
